// extracted by mini-css-extract-plugin
export default {"container":"catalog-items_container__Papkd"};